












































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import PasienNote from "@/services/new/PasienNote";
import { confirmRemove } from "@/utility/CommonHelper";
import PasienTag from "@/services/new/PasienTag";

@Component({})
export default class CardModalDetailPasien extends Vue {
  @Prop() readonly value!: boolean;
  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }
  getHumanDate(date) {
    return date ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY") : "";
  }

  showInputNote = false;
  note = null;
  id = null;
  savingNote = false;
  noteList = [];
  disabilitas = false;
  tbc = false;
  hiv = false;

  @Watch("showInputNote")
  changeShowInputNote(val) {
    if (!val) {
      this.note = null;
      this.id = null;
    }
  }
  @Watch("storePasienNote")
  changeStorePasienNote(val) {
    this.noteList = val;
  }

  get storePasienNote() {
    return storePasien.note;
  }
  get noteParam() {
    return {
      note: this.note
    };
  }
  get pasienTag() {
    return storePasien.pasienTag;
  }
  get pasienTagName() {
    return this.pasienTag.map(it => it.name);
  }

  @Watch("value")
  changedValue(val: Array<string>) {
    console.log("changed value", val);

    this.disabilitas = this.pasienTagName.includes("disability");
    this.tbc = this.pasienTagName.includes("tbc");
    this.hiv = this.pasienTagName.includes("hiv");
  }

  saveNote() {
    if (!this.savingNote) {
      this.savingNote = true;
      this.id
        ? PasienNote.updateNote(this.statePasien.rm, this.id, this.noteParam)
            .then(resp => {
              if (resp.status) {
                const nt = this.noteList.find(it => it.id == this.id);
                nt.note = resp.data.note;
              }

              this.showInputNote = false;
            })
            .finally(() => {
              this.savingNote = false;
            })
        : PasienNote.createNote(this.statePasien.rm, this.noteParam)
            .then(resp => {
              if (resp.status) {
                this.noteList.push(resp.data);
              }

              this.showInputNote = false;
            })
            .finally(() => {
              this.savingNote = false;
            });
    }
  }
  editNote(note) {
    this.note = note.note;
    this.id = note.id;
    this.showInputNote = true;
  }
  deleteNote(note) {
    const q = confirmRemove("Catatan Pasien");

    if (q) {
      PasienNote.deleteNote(this.statePasien.rm, note.id).then(resp => {
        if (resp.status) {
          this.noteList.splice(
            this.noteList.findIndex(it => it.id == note.id),
            1
          );
        }
      });
    }
  }

  setPasienTag(tag: string, val) {
    console.log("set pasien tag", tag, val, this.statePasien.rm);

    if (val) {
      PasienTag.setTag(this.statePasien.rm, tag).then(resp => {
        if (resp.status == 1) {
          storePasien.getPasienTag();
        }
      });
    } else {
      PasienTag.removeTag(this.statePasien.rm, tag).then(resp => {
        if (resp.status == 1) {
          storePasien.getPasienTag();
        }
      });
    }
  }
}
